module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-down-left-2.e8bc67d3.png";